import { switchMap } from 'rxjs';
import { fromFetch } from 'rxjs/fetch';
import { getBuildablePlanNearbylistingsInfo } from 'constants/routes'

/**
 * Retrieves additional information for a buildable plan nearby listings carousel.
 * @param {Object} payload - The payload containing the community id.
 * @returns {Observable} - An observable that emits the additional marker information.
 */
function getBuildablePlanNearbyListings(payload) {
  const {id, showPlanCards} = payload;
  const url = `${getBuildablePlanNearbylistingsInfo}?id=${id}`;

  return fromFetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'image/webp',
    }
  }).pipe(
    switchMap(async (response) => {
      const data = await response.json();
      const { community, plans } = data;

      // get a combined list with the community being the first item
      // then a list of the community plans if showPlanCards is true.
      // if showPlanCards is false, just return the community.
      // this is avoid displaying multiple cards on desktop devices.
      return showPlanCards ? [...community, ...plans] : [...community];
      
    })
  );
}

export default getBuildablePlanNearbyListings;